module.exports = __webpack_public_path__ + "static/img/gcash-icon.f4329e54.png";